import { useVirtualizer } from '@tanstack/react-virtual';
import { rootLogger } from '@/lib/root-logger';

const moduleLogger = rootLogger.child({ module: 'DocReaderVirtual' });

export const tanstackScrollToIndex = (
  // handle: Virtualizer<HTMLDivElement, Element>,
  handle: ReturnType<typeof useVirtual>,
  index: number,
) => {
  try {
    handle.scrollToIndex(index, { behavior: 'auto', align: 'start' });
  } catch (error) {
    moduleLogger.warn({ error, index }, 'tanstackScrollToIndex failed');
    // Rethrow: the follow controller retries failed scrolls; a swallowed page
    // jump stays deduped as lastScrolled forever.
    throw error;
  }
};

export const useVirtual = (options: Parameters<typeof useVirtualizer>[0]) => {
  'use no memo';

  // oxlint-disable-next-line react/incompatible-library -- TanStack Virtual's callbacks cannot be memoized without going stale; the directive above opts this hook out of the compiler for that reason
  const virtualizer = useVirtualizer(options);
  const {
    getVirtualItems,
    getTotalSize,
    scrollToIndex,
    scrollToOffset,
    measureElement,
    getOffsetForIndex,
    range,
    isScrolling,
    scrollElement,
  } = virtualizer;

  return {
    virtualItems: getVirtualItems(),
    totalSize: getTotalSize() /*...and whatever else you need*/,
    scrollToIndex,
    scrollToOffset,
    measureElement,
    getOffsetForIndex,
    range,
    isScrolling,
    scrollElement: scrollElement as HTMLDivElement | null,
  };
};
